import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import { GroupDataFragmentDoc } from '../../../components/__generated__/groupBasicInfo.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type YourCommunityGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type YourCommunityGroupsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', adminOfCommunityGroups: Array<{ __typename?: 'CommunityGroup', id: string, uuid: string, name: string, description?: string | null, members: Array<{ __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }> }>, communityInvites: Array<{ __typename?: 'JoinInvite', id: string, communityGroup: { __typename?: 'CommunityGroup', id: string, uuid: string, name: string, description?: string | null, members: Array<{ __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }> } }>, memberOfCommunityGroups: Array<{ __typename?: 'CommunityGroup', id: string, uuid: string, name: string, description?: string | null, members: Array<{ __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }> }> } };


export const YourCommunityGroupsDocument = gql`
    query YourCommunityGroups {
  currentUser {
    adminOfCommunityGroups {
      ...GroupData
    }
    communityInvites {
      id
      communityGroup {
        ...GroupData
      }
    }
    memberOfCommunityGroups {
      ...GroupData
    }
  }
}
    ${GroupDataFragmentDoc}`;

/**
 * __useYourCommunityGroupsQuery__
 *
 * To run a query within a React component, call `useYourCommunityGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useYourCommunityGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYourCommunityGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useYourCommunityGroupsQuery(baseOptions?: Apollo.QueryHookOptions<YourCommunityGroupsQuery, YourCommunityGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YourCommunityGroupsQuery, YourCommunityGroupsQueryVariables>(YourCommunityGroupsDocument, options);
      }
export function useYourCommunityGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YourCommunityGroupsQuery, YourCommunityGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YourCommunityGroupsQuery, YourCommunityGroupsQueryVariables>(YourCommunityGroupsDocument, options);
        }
// @ts-ignore
export function useYourCommunityGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<YourCommunityGroupsQuery, YourCommunityGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<YourCommunityGroupsQuery, YourCommunityGroupsQueryVariables>;
export function useYourCommunityGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YourCommunityGroupsQuery, YourCommunityGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<YourCommunityGroupsQuery | undefined, YourCommunityGroupsQueryVariables>;
export function useYourCommunityGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YourCommunityGroupsQuery, YourCommunityGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YourCommunityGroupsQuery, YourCommunityGroupsQueryVariables>(YourCommunityGroupsDocument, options);
        }
export type YourCommunityGroupsQueryHookResult = ReturnType<typeof useYourCommunityGroupsQuery>;
export type YourCommunityGroupsLazyQueryHookResult = ReturnType<typeof useYourCommunityGroupsLazyQuery>;
export type YourCommunityGroupsSuspenseQueryHookResult = ReturnType<typeof useYourCommunityGroupsSuspenseQuery>;
export type YourCommunityGroupsQueryResult = Apollo.QueryResult<YourCommunityGroupsQuery, YourCommunityGroupsQueryVariables>;